import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpRequestService } from 'src/app/_services/http-request.service';
import { DataSharingService } from 'src/app/_services/data-sharing.service';
import { tap } from 'rxjs/operators';
import { Equity } from 'src/app/_models/equity';

@Component({
  selector: 'app-interest-overview',
  templateUrl: './interest-overview.component.html',
  styleUrls: ['./interest-overview.component.css']
})
export class InterestOverviewComponent implements OnInit {

  equityData: Equity[];
  allInterest: any[] = [];
  interestPaid: any[] = [];
  interestPaidInBase: number = 0;
  interestReceived: any[] = [];
  interestReceivedInBase: number = 0;
  interestWitholdingTax: any[] = [];
  interestWitholdingTaxTotal: number = 0;
  interestAccruals: number = 0;
  filterValueSYEP: string = "YIELD ENHANCEMENT INCOME"
  filterValueCreditWithHolding: string = "ON CREDIT INT"


  belgiumYearlyStatement: boolean;

  constructor(private httpRequestService: HttpRequestService, private dataSharingService: DataSharingService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.checkIfBelgiumStatements();
    this.getEquityAndComputeInterest();
  }

  checkIfBelgiumStatements() {
    if (this.route.snapshot.paramMap.get("country") && this.route.snapshot.paramMap.get("country").toUpperCase() === 'BE') {
      this.belgiumYearlyStatement = true;
    }else{
      this.belgiumYearlyStatement = false;
    }
  }

  getEquityAndComputeInterest() {
    return this.httpRequestService.equityData.pipe(tap(responseData => {
      this.resetValues();
      if (responseData.length === 0) return;
      this.equityData = responseData;
      this.computeInterest();
    })).toPromise();
  }

  computeInterest() {
    this.allInterest = this.equityData.map(x => x.transfers.filter(y => y.description.indexOf(this.filterValueSYEP) !== -1 || y.description.indexOf(this.filterValueCreditWithHolding) !== -1 || y.typeDescription === "Broker Interest Paid" || y.typeDescription === "Broker Interest Received" || y.typeDescription === "Bond Interest Paid" || y.typeDescription === "Bond Interest Received" || y.instrumentSecurityType === 'BOND'))
      .reduce((acc, val) => acc.concat(val), []); // flatten the array[]
    this.interestPaid = this.allInterest.filter(x => x.typeDescription === "Broker Interest Paid" || x.typeDescription === "Bond Interest Paid");
    this.interestReceived = this.allInterest.filter(x => x.typeDescription === "Broker Interest Received" || x.typeDescription === "Bond Interest Received");
    this.interestPaidInBase = this.interestPaid.reduce((acc, val) => acc + val.value, 0);
    this.interestReceivedInBase = this.interestReceived.reduce((acc, val) => acc + val.value, 0);
    this.dataSharingService.sendInterestTotal(this.interestPaidInBase + this.interestReceivedInBase);
    this.interestAccruals = this.equityData[this.equityData.length - 1].assets.interestAccruals;
    this.interestWitholdingTax = this.allInterest.filter(x => x.typeDescription === "Withholding Tax");
    this.interestWitholdingTaxTotal = this.interestWitholdingTax.reduce((acc, val) => acc + val.value, 0);
  }

  resetValues() {
    this.allInterest = [];
  }
}
